import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import Contact from '../components/Contact/Contact';
import { ContactPartnerExample } from '../templateObjects/internationalContact';
import { useI18next } from 'gatsby-plugin-react-i18next';
import { staticPageRedirection } from '../utils/staticPagesRedirection';
import { CONTACT_ES_ES_LANGUAGES } from '../constants/sitesLanguagesGroup';
import Alternate from '../components/Seo/Alternate';
import { prepareAlternateData } from '../utils/prepareAlternateData';

const ContactPage = ({
    data: {
        drupal: {
            contact_partners: { data: partnersData },
        },
    },
}) => {
    const { language } = useI18next();
    const languagesWithUrls = [];
    process.env.LANGUAGES.split(',').forEach((language: string) =>
        languagesWithUrls.push(prepareAlternateData(language, 'contact'))
    );

    useEffect(() => {
        staticPageRedirection(language, 'contact', CONTACT_ES_ES_LANGUAGES);
    }, []);

    return (
        <>
            <Alternate languages={languagesWithUrls} />
            <Contact contactPartner={partnersData !== null ? JSON.parse(partnersData) : ContactPartnerExample} />
        </>
    );
};

export default ContactPage;

export const query = graphql`
    query ($language: String!) {
        drupal {
            contact_partners {
                data
            }
        }
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
    }
`;
